import api from './api';

export interface AnalyticsData {
  campaign_performance?: any;
  content_performance?: any;
  lead_analytics?: any;
  engagement_metrics?: any;
}

export const analyticsService = {
  getCampaignAnalytics: async (campaignId: string, periodDays: number = 30) => {
    const response = await api.get(`/campaigns/${campaignId}/analytics`, {
      params: { period_days: periodDays },
    });
    return response.data;
  },

  getContentAnalytics: async (periodDays: number = 30) => {
    const response = await api.get('/analytics/content', {
      params: { period_days: periodDays },
    });
    return response.data;
  },

  getLeadAnalytics: async (periodDays: number = 30) => {
    const response = await api.get('/analytics/leads', {
      params: { period_days: periodDays },
    });
    return response.data;
  },

  getWorkspaceAnalytics: async (periodDays: number = 30) => {
    const response = await api.get('/analytics/overview', {
      params: { period_days: periodDays },
    });
    return response.data;
  },

  getTrendingTopics: async () => {
    const response = await api.get('/analytics/trending-topics');
    return response.data;
  },

  getEngagementMetrics: async (periodDays: number = 30) => {
    const response = await api.get('/analytics/engagement', {
      params: { period_days: periodDays },
    });
    return response.data;
  },

  getConversionFunnel: async (workspaceId: string, periodDays: number = 30) => {
    const response = await api.get(`/workspaces/${workspaceId}/analytics/conversion-funnel`, {
      params: { period_days: periodDays },
    });
    return response.data;
  },

  exportReport: async (workspaceId: string, reportType: string, format: string = 'csv') => {
    const response = await api.get(
      `/workspaces/${workspaceId}/analytics/export`,
      {
        params: { report_type: reportType, format },
        responseType: 'blob',
      }
    );
    return response.data;
  },
};
